import { Accordion } from '@dreryk/react-components';

import { StyledAccordionSectionContent } from '../HealthcareProviderPatientPortalPanel.styled';
import { boundServiceTranslationKeys } from '../../translations';

import { CurrentHealthcareProviderBoundServiceTable } from './CurrentHealthcareProviderBoundServiceTable';

const t = boundServiceTranslationKeys;

type CurrentHealthcareProviderBoundServiceSectionProps = Readonly<{
   id: string;
}>;

export const CurrentHealthcareProviderBoundServiceSection = (
   props: CurrentHealthcareProviderBoundServiceSectionProps
): JSX.Element => {
   return (
      <Accordion.Section id={props.id} testId={props.id} label={t.servicesAvailableInPatientPortal}>
         <StyledAccordionSectionContent>
            <CurrentHealthcareProviderBoundServiceTable />
         </StyledAccordionSectionContent>
      </Accordion.Section>
   );
};
